import type { SummaryResponse } from '../types'

const HEADINGS: Array<[key: keyof NonNullable<SummaryResponse['sections']>, label: string]> = [
  ['wants', 'Customer wants'],
  ['done', 'Already done'],
  ['open', 'Still open'],
]

/**
 * The conversation in three lines, for an agent picking the ticket up.
 *
 * Falls back to the raw text when `sections` is null. The model is asked for
 * three fixed headings and usually obeys, but a summary rendered as one
 * unlabelled block is still worth reading — showing nothing because a heading
 * was missing would not be.
 */
export function SummaryCard({ summary }: { summary: SummaryResponse }) {
  return (
    <div className="card">
      <h2>
        Summary <span className="tag">{summary.messages} read</span>
      </h2>

      {/* Heading above its paragraph, not beside it. The two-column layout
          this replaces gave each summary half the panel's width, so a couple of
          sentences became a tall thin column of three or four words a line. */}
      {summary.sections ? (
        <div className="summary-sections">
          {HEADINGS.map(([key, label]) => (
            <section key={key}>
              <h3>{label}</h3>
              <p>{summary.sections![key]}</p>
            </section>
          ))}
        </div>
      ) : (
        <p className="summary-raw">{summary.summary}</p>
      )}

      <p className="note">From this ticket only. The knowledge base is not used here.</p>
    </div>
  )
}
